import {
    Checkbox,
    Col,
    DatePicker,
    Form,
    Input,
    Modal,
    notification,
    Row,
    Space,
    Table,
} from 'antd';
import Link from 'antd/es/typography/Link';
import dayjs from 'mixins/dayjsConfig.js';
import Button from 'mixins/ui/button/button';
import React, { useEffect, useState } from 'react';
import { IPollData, IShownComponents, TServiceUrl } from '../express-help.types';
import EditQuestionnaireModal from '../modals/modal-edit-poll';
import {
    deleteQuestionnaireById,
    getQuestionnaireList,
    searchQuestionnaire,
} from '/react4xp/parts/express-help/actions';

const PollScreen = (props: any) => {
    const [data, setData] = useState<IPollData[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isBeingDeleted, setIsBeingDeleted] = useState(false);
    const [selectedObject, setSelectedObject] = useState<IPollData>();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);
    const [total, setTotal] = useState(0);

    const { confirm } = Modal;
    const [form] = Form.useForm();

    const serviceType: TServiceUrl = { service: 'Questionnaire' };

    const loadQuestionaires = () => {
        setIsLoading(true);

        getQuestionnaireList({ page: pageNumber - 1, size: pageSize })
            .then((response) => {
                setData(response.data.content);
                setTotal(response.data.totalElements);
            })
            .finally(() => setIsLoading(false));
    };

    const deleteQuestionnaire = (id: number) => {
        confirm({
            title: 'Подтвердите действия удаления данных',
            onOk() {
                setIsBeingDeleted(true);

                deleteQuestionnaireById(id)
                    .then(() => {
                        notification['success']({
                            message: 'Данные успешно удалены!',
                        });
                        loadQuestionaires();
                    })
                    .catch(() => {
                        notification['error']({
                            message: 'Ошибка',
                            description:
                                'Невозможно удалить запись. Требуется сначало удалить вопросы и ответы опроса',
                        });
                    })
                    .finally(() => setIsBeingDeleted(false));
            },
        });
    };

    const editQuestionnaire = (doc: any) => {
        setIsModalOpen(true);
        setSelectedObject(doc);
    };

    const showQuestions = (docId: number) => {
        moveToScreen({
            mainPageShown: false,
            pollPageShown: false,
            pollItemPageShown: true,
            questionPageShown: false,
            answerPageShown: false,
            idOfQuestionnaire: docId,
            editMode: true,
        });
    };

    const moveToScreen = (nextScreenParameter: IShownComponents) => {
        props.showNext(nextScreenParameter);
    };

    const handleOk = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
        loadQuestionaires();
    };

    const handleCancel = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
    };

    const onActionClick = (key: string, doc: any) => {
        switch (key) {
            case 'EDIT':
                editQuestionnaire(doc);
                break;
            case 'DELETE':
                deleteQuestionnaire(doc.id);
                break;
            case 'SHOW':
                showQuestions(doc.id);
                break;
        }
    };

    const columnsQuestionnaire = [
        {
            title: 'ИД',
            dataIndex: 'id',
        },
        {
            title: 'Наименование на казахском языке',
            dataIndex: 'questionnaireKk',
        },
        {
            title: 'Наименование на русском языке',
            dataIndex: 'questionnaireRu',
        },
        {
            title: 'Наименование на английском языке',
            dataIndex: 'questionnaireEn',
        },
        {
            title: 'Создал/Изменил',
            dataIndex: 'username',
            render: (_, item) =>
                item.user && item.user.name
                    ? `${item.user.name.lastname} ${item.user.name.firstname}`
                    : item.username,
        },
        {
            title: 'Вес',
            dataIndex: 'questionnaireWeight',
        },
        {
            title: 'Дата создания/изменения',
            dataIndex: 'changeDate',
            render: (changeDate) => {
                return dayjs(changeDate).format('DD.MM.YYYY HH:mm:ss');
            },
        },
        {
            title: 'Действия',
            width: 180,
            render: (text, record) => (
                <span>
                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('DELETE', record);
                        }}
                    >
                        Удалить
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('EDIT', record);
                        }}
                    >
                        Редактировать
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('SHOW', record);
                        }}
                    >
                        Просмотр
                    </Link>
                </span>
            ),
        },
    ];

    const handlePaginationChange = (pagination) => {
        setPageNumber(pagination.current);
        setPageSize(pagination.pageSize);
    };

    useEffect(() => {
        loadQuestionaires();
    }, [pageNumber, pageSize]);

    const onFinish = (values) => {
        searchQuestionnaire(values).then((response) => {
            setData(response.data.content);
        });
    };

    const clear = () => {
        form.resetFields();
        loadQuestionaires();
    };

    return (
        <div className="poll-screen">
            <h4>Опросы</h4>

            <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                className="my-3"
            >
                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="username"
                            label="Создал/Изменил"
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="changeDateFrom"
                            label="Дата изменения C"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="changeDateTo"
                            label="По"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="questionnaire"
                            label="Наименование рус."
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="published"
                            valuePropName="checked"
                            initialValue={false}
                        >
                            <Checkbox>Опубликованные</Checkbox>
                        </Form.Item>
                    </Col>
                </Row>

                <Row gutter={{ xs: 8, md: 12 }}>
                    <Col
                        xs={24}
                        md={12}
                        className="d-flex justify-content-start"
                    >
                        <Space wrap>
                            <Button onClick={clear}>Сброс</Button>
                            <Button
                                color="gold"
                                type="primary"
                                htmlType="submit"
                            >
                                Поиск
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>

            <Row
                gutter={{ xs: 24, md: 24 }}
                className="my-3"
            >
                <Col
                    xs={24}
                    md={12}
                >
                    <h4>Список опросов</h4>
                </Col>
                <Col
                    xs={24}
                    md={12}
                    className="d-flex justify-content-end"
                >
                    <Button
                        className="poll-screen__btn-submit"
                        color="gold"
                        onClick={() =>
                            moveToScreen({
                                mainPageShown: false,
                                pollPageShown: true,
                                questionPageShown: false,
                                answerPageShown: false,
                                editMode: false,
                            })
                        }
                    >
                        Создать опрос
                    </Button>
                </Col>
            </Row>

            <Table
                dataSource={data}
                columns={columnsQuestionnaire}
                loading={isLoading}
                pagination={{
                    current: pageNumber,
                    pageSize,
                    total,
                    showSizeChanger: true,
                }}
                scroll={{
                    x: true,
                }}
                onChange={handlePaginationChange}
            />

            <EditQuestionnaireModal
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                selectedObject={selectedObject}
                selectedType={serviceType}
            />
        </div>
    );
};

export default PollScreen;
